import { render, staticRenderFns } from "./ProvRemRequestManagement.vue?vue&type=template&id=a4e37d10"
import script from "./ProvRemRequestManagement.vue?vue&type=script&lang=js"
export * from "./ProvRemRequestManagement.vue?vue&type=script&lang=js"
import style0 from "./ProvRemRequestManagement.vue?vue&type=style&index=0&id=a4e37d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports